import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import styles from './HelpIcon.module.scss';
import { Button } from '@jutro/legacy/components';

function HelpIcon({ onClick }) {
    return (
        <Fragment>
            <Button
                icon="mi-help_outline"
                className={styles.helpIcon}
                onClick={onClick}
            />
        </Fragment>
    );
}

HelpIcon.propTypes = {
    onClick: PropTypes.func,
};

HelpIcon.defaultProps = {
    onClick: _.noop,
};

export default HelpIcon;
